<template>
  <FeedFilterTag :on-click="handleClick">
    {{ data }} {{ typeof data === 'number' ? $t('text-unit-km') : '' }}
  </FeedFilterTag>
</template>

<script setup>
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

defineProps({
  type: {
    type: String,
    required: true
  },
  data: {
    type: [String, Number],
    required: true
  }
});

const route = useRoute();

const handleClick = async () => {
  const params = { ...route.query };
  delete params['maxKmFromHome'];
  delete params['maxKmFromLocation'];
  delete params['location'];
  delete params['latitude'];
  delete params['longitude'];
  await navigatorTo({ path: route.path, query: params });
}

</script>
